export default __webpack_public_path__ + "static/media/add-round-filled-blue-16px.2a07a4f7.svg";